import ApiConstants from '../../constants/ApiConstants';
import checkResults from './checkResults.js';
import xhr from './xhr';

const LanguageApiUtils = {
  fetch() {
    return xhr(ApiConstants.FetchLanguages).then(checkResults);
  },
};

export default LanguageApiUtils;
